import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import { formatInTimeZone } from "date-fns-tz";
import "../Body/Body.css";

export default function Body({ bannerData, links }) {
  const imgCDNURL = process.env.REACT_APP_OCTOBER_CDN_URL;
  return (
    <>
      <div className="banner">
        <Container>
          <Row>
            <Col lg={6} md={12} sm={12} xs={12}>

              <div className="bannertextdesktop">
                <p className="mastermind">{htmlParser(bannerData.mastermindbannerheading)}</p>
              </div>
              <div className="bannertextsub">
                <p>{htmlParser(bannerData.mastermindsubheading1)}</p>
              </div>
              <div className="bannertextsubpara">
                <p>{htmlParser(bannerData.mastermindsubheading2)}</p>
              </div>

              {/* <img
                src={imgCDNURL + "banner-image-desktop.webp"}
                className="mobilegroup"
              ></img> */}
              {/* <img
                src={imgCDNURL + "banner-image-mobile.webp"}
                className="mobilegroup-mobile"
              ></img> */}
            </Col>
          </Row>
          <div className="desk-explore">
            <Row className="exploreandeditoin">
              <Col lg={3} md={6} sm={6} xs={6}>
                <div className="editionbox">
                  <div className="edition">
                    <p className="textedition">
                      {htmlParser(bannerData.monthedition)}
                    </p>                    
                  </div>
                </div>
              </Col>
              <Col lg={6} md={6} sm={6} xs={6}>
                <div className="explorebtn">
                  <p className="exploretext">Explore Now</p>
                </div>
              </Col>
              <Col lg={3} md={0} sm={0} xs={0} className="blankcol"></Col>
            </Row>
          </div>
        </Container>
        <div className="mobile-explore">
        <div className="exploreandeditoinmobile d-flex">
          <Col lg={7} md={9} sm={9} xs={9}>
            <div className="editionbox">
              <div className="edition">
                <p className="textedition">
                  {htmlParser(bannerData.montheditionmobile)}
                </p>
              </div>
            </div>
          </Col>
        </div>
        </div>
      </div>

    </>
  );
}
